
import { useController } from '@/domain/services/Composer';

import { defineComponent } from 'vue';
import { aiAgentFieldController, Props, View } from '@/lib/components/Fields/AIAgentField.controller';
import { Resource } from '@/modules/ai-agents/AIAgents.types';
import { Field } from '@/domain/models/Field';
import { Popover } from 'vue-bootstrap';

export default defineComponent<Props, View>({
	components: {
		Popover,
	},
	props: {
		field: {
			type: Object as unknown as Field,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		resource: {
			type: String as unknown as Resource,
			default: null,
		},
		resourceSlug: {
			type: String,
			default: null,
		},
		pusherOptions: {
			type: String,
			default: null,
		},
		consumerChannelKey: {
			type: String,
			default: null,
		},
	},
	setup: useController(aiAgentFieldController, 'aiAgentFieldController') as () => View,
});
